<template>
  <div id="app">
    <Menu/>
    <main id="content">
      <FollowLinks/>
      <!-- <transition name="slide-fade"> -->
        <router-view></router-view>
      <!-- </transition> -->
    </main>
  </div>
</template>

<script>
import Menu from './components/Menu.vue'
import FollowLinks from './components/FollowLinks.vue'

export default {
  name: 'app',
  data () {
    return {}
  },
  components: {
    Menu,
    FollowLinks
  }
}

</script>

<style lang="scss">
@import './variables.scss';
@import url('https://fonts.googleapis.com/css?family=Goudy+Bookletter+1911|Roboto');

html, body {
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Goudy Bookletter 1911', serif;
  font-size: 1.5em;
  background-color: $gray;
  color: $white;
  min-width: 1000px;
}

* {
  /*-moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box; */
  transition: all 0.2s ease;
}

#app {
  display: flex;
  flex-wrap: nowrap;
}

#content {
  padding: 50px 90px 50px 320px;
}

.followlinks {
  position: absolute;
  top: 40px;
  left: calc(100vw - 595px);
  text-align: right;
  width: 500px;
}

@media (max-width: 1225px) {
  .followlinks {
    left: calc(635px);
  }
}

h1 {
  display: inline;
  font-family: 'Roboto', sans-serif;
  font-size: 2.5em;
  position: relative;
  bottom: -25px;
  margin-left: 50px;
  mix-blend-mode: difference;
}

.banner {
  margin: 30px 0;
  height: 400px;
}

section {
  background-color: $white;
  color: $gray;
  padding: 50px;
  font-size: 0.9em;
  border-radius: 3px;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.5);
  min-width: 700px;
  width: calc(100vw - 530px);
}

section:nth-child(n+3):before {
  content: '';
  display: block;
  width: 55px;
  height: 30px;
  background-color: $gray;
  position: relative;
  top: -80px;
  left: -150px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.red {
  color: $red;
}

article a, article a:visited {
  color: $blue;
}
article a:hover {
  color: $gray;
}

article {
  backface-visibility: hidden;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}

</style>
